import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EmrModalComponent, GetAlertSuspendStatusRequest } from 'emr-ng-shared';
import { AlertSuppressionComponent } from '../alert-suppression/alert-suppression.component';

@Component({
  selector: 'app-alert-suppression-popup',
  templateUrl: './alert-suppression-popup.component.html',
  styleUrls: ['./alert-suppression-popup.component.css'],
  standalone: true,
  imports: [EmrModalComponent, AlertSuppressionComponent]
})
export class AlertSuppressionPopupComponent implements OnInit {

  constructor(
    public bsAlertSuppressionModalRef: BsModalRef
  ) { }

  alertSuspendStatusRequest: GetAlertSuspendStatusRequest;

  ngOnInit() {
  }

  onPopupCancel() {
    this.bsAlertSuppressionModalRef.hide();
  }

}


